/**
 * 与 Trade/_cmpt/market 一致：USDT 本位 CFD 下 Crypto 对应 tab key 为 usds（非 crypto）。
 * 从 More 等入口跳转 /futures/contract 前写入，避免打开行情面板时 Crypto/Stocks/Commodities 高亮与当前品类不一致。
 */
import tabCfgAry from "@/components/Pages/Trade/_cmpt/market/tabs/tabCfgAry";
import Storage from "@/utils/storage";

const CATEGORY_TO_TAB_KEY = {
  crypto: "usds",
  stocks: "stocks",
  commodities: "commodities",
};

/**
 * @param {"crypto"|"stocks"|"commodities"} cfdCategory
 */
export function setMarketGroupStorageForCfdCategory(cfdCategory) {
  const tabKey = CATEGORY_TO_TAB_KEY[cfdCategory];
  if (!tabKey) return;
  const cfg = tabCfgAry.find((item) => item.key === tabKey);
  if (cfg) Storage.set("marketGroup", cfg);
}
